import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  subjectInfo: {}
};

export default function subject(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 清除专题页信息
    case ACTION_TYPES.CLEAR_SUBJECT_INFO:
      result.subjectInfo = INIT_STATE.subjectInfo;
      break;
    // 获取专题页信息
    case ACTION_TYPES.GET_SUBJECT_INFO:
      result.subjectInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
